import ModalStore from './ModalStore'
import { insuranceProductServer } from '../common/api'

class HealthProduct extends ModalStore {
  constructor() {
    super('healthProductStore', {
      all: [],
      current: {},
      configs: [],
    })
  }

  fetch = async param => {
    const res = await insuranceProductServer.get('/health_products', param)
    this.$setState('all', res.data.data.products)
  }

  create = async param => {
    await insuranceProductServer.post('/health_products', {
      ...param,
    })
  }

  fetchConfig = async () => {
    const resConfigs = await insuranceProductServer.get(
      `/health_products/configs`
    )
    this.$setState('configs', resConfigs.data.data.configs.attributes)
  }

  fetchById = async param => {
    const res = await insuranceProductServer.get(`/health_products/${param}`)

    this.$setState('current', res.data.data.product)
  }

  update = async (id, param) => {
    const res = await insuranceProductServer.put(`/health_products/${id}`, {
      ...param,
    })
    this.$setState('current', res.data.data.product)
  }

  delete = async id => {
    await insuranceProductServer.delete(`/health_products/${id}`)
  }

  updateStatusPublishDetail = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/health_products/${id}/publish`
    )

    this.$setState('current', res.data.data.product)
  }

  updateStatusUnpublishedDetail = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/health_products/${id}/unpublished`
    )

    this.$setState('current', res.data.data.product)
  }

  updateStatusPublish = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/health_products/${id}/publish`
    )
    const response = res.data.data

    const products = this.$getState('all')

    await products.forEach(product => {
      if (product.id === response.product.id) {
        product.status = response.product.status
      }
    })

    this.$setState('all', products)
  }

  updateStatusUnpublished = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/health_products/${id}/unpublished`
    )
    const response = res.data.data

    const products = this.$getState('all')

    await products.forEach(product => {
      if (product.id === response.product.id) {
        product.status = response.product.status
      }
    })

    this.$setState('all', products)
  }

  clearData = () => {
    this.$setState('configs', [])
    this.$setState('current', [])
  }
}

export default new HealthProduct()
